import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store/types/RootState';
import { SortDirection } from '@/enums/SortDirection';

export const selectPaymentListByClaimId = ({ claimId }: { claimId: number }) =>
  createSelector([(state: RootState) => state.payments.paymentsMapByClaimId, () => claimId], (mapByClaimId, id) => {
    const list = mapByClaimId[id]?.paymentList;
    return list ?? [];
  });

export const selectPaymentByClaimIdIsLoading =
  ({ claimId }: { claimId: number }) =>
  (state: RootState) =>
    state.payments.paymentsMapByClaimId[claimId]?.isLoading || false;

export const selectPaymentDetails = (state: RootState) => state.payments.paymentDetails;
export const selectPaymentDetailsStatus = (state: RootState) => state.payments.statuses.isPaymentDetailsLoading;

export const selectPaymentTransactionsById = (id: number) => (state: RootState) =>
  state.payments.transactionDetails.byPaymentId[id]?.listings ?? [];

export const selectPaymentTransactionsDetailsPagination = (id: number | string) => (state: RootState) =>
  state.payments.transactionDetails.byPaymentId[id]?.pagination ?? {
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 5,
    },
  };

export const selectPaymentTransactionsDetailsSorting = (paymentId: string | number) => (state: RootState) =>
  state.payments.transactionDetails.byPaymentId[paymentId]?.sorting ?? {
    sortBy: 'createdAt',
    sortDirection: SortDirection.ASC,
  };

export const selectHideCompleteTransactions = (paymentId: string | number) => (state: RootState) =>
  state.payments.transactionDetails.byPaymentId[paymentId]?.hideCompleteTransactions ?? false;

export const selectPaymentTransactionsDetailsStatuses = (paymentId: string | number) => (state: RootState) =>
  state.payments.statuses.paymentTransactionsDetails[paymentId] ?? {
    isLoading: false,
    isFetching: false,
    isError: false,
    isSuccess: false,
  };
